import RiyalIcon from "../../../icons/riyalIcon";
import { PiCurrencyDollarSimple } from "react-icons/pi";

const Stats = ({ t }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#D1A85566] ">
          <PiCurrencyDollarSimple className="text-white" size={24} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">{t("attendees")}</p>
          <p className="text-[32px] font-bold flex items-center gap-2">
            89,000
            <RiyalIcon fill={"white"} />
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#EAFFE6] ">
          <PiCurrencyDollarSimple className="text-[#11A849]" size={24} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">{t("totalBonuses")}</p>
          <p className="text-[32px] text-[#96E9B5] font-bold flex items-center gap-2">
            16,500
            <RiyalIcon fill={"#96E9B5"} />
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#FFE6E6] ">
          <PiCurrencyDollarSimple className="text-[#C42E27]" size={24} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">
            {t("totalDeductions")}
          </p>
          <p className="text-[32px] text-[#C42E27] font-bold flex items-center gap-2">
            2,500
            <RiyalIcon />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Stats;
